import {
    Col,
    Modal,
    ModalHeader,
    Row,
} from "reactstrap";
import 'assets/css/admin_user_filters_modal.css'

import React, { useEffect, useMemo, useState } from 'react';

import useFeatureFlags from "hooks/useFeatureFlags";
import { useSelector } from "react-redux";
import runded_phone_icon from "assets/images/rounded-circle-phone.svg"
import useClearableTimeout from "hooks/useClearableTimeout";
import { REQUIRED_FEATURE_FLAGS } from "helpers/sf_constants";
import { capitalize } from "lodash";
import useQuoteFunnelOrderedQuestions from "hooks/useQuoteFunnelOrderedQuestions";
import { popupTextRegExp } from "common/utils/data_validations";
import { formatPhoneNumber } from "helpers/quote_funnel_helper";

const CallNowPopupModal = ({ lead_type_id, variable_mappings }) => {

    const [isFeatureFlagActive] = useFeatureFlags();
    const [isActive, setIsActive] = useState(false);
    const [questions] = useQuoteFunnelOrderedQuestions();

    const { answer_agent_profile, agent_profile_popup_message, quote_funnel_questions } = useSelector((state) => ({
        answer_agent_profile: state.QuoteFunnelAnswersAgentProfileReducer.answer_agent_profile,
        agent_profile_popup_message: state.QuoteFunnelRedcuer.agent_profile_popup_message,
        quote_funnel_questions: state.QuoteFunnelAnswersAgentProfileReducer.quote_funnel_questions
    }))

    const currentAgentProfileMessage = useMemo(() => {
        return agent_profile_popup_message?.find(item => item?.lead_type_id == lead_type_id)
    }, [agent_profile_popup_message, lead_type_id])

    const [customSetTimeout] = useClearableTimeout()

    const HandleModalClose = () => {
        setIsActive(false)
    }

    const filteredMacros = useMemo(() => {
        const result = []
        questions?.forEach(question => {
            if (question?.field_name) {
                result.push({ [question.field_name]: question.value });
            }
            if (question?.original_field_name) {
                result.push({ [question.original_field_name]: question.value });
            }
        });
        return result;
    }, [quote_funnel_questions])

    const mappedResult = useMemo(() => {
        const mappedResultArr = []
        filteredMacros.map(item => {
            const mappedItem = {};
            for (const mapping of variable_mappings) {
                const [key, value] = Object.entries(mapping)[0];
                if (item.hasOwnProperty(value)) {
                    mappedItem[key] = item[value];
                }
            }
            if (Object.keys(mappedItem).length) {
                mappedResultArr.push(mappedItem);
            }
        });

        return mappedResultArr;
    }, [filteredMacros])

    const getKeyFromMappedResult = (key) => {
        const foundItem = mappedResult.find(item => Object.keys(item)[0] === key);
        return foundItem ? capitalize(foundItem[key]) : null;
    };

    const populateStringWithMacros = (str) => {
        if (mappedResult?.length) {
            return str?.replace(popupTextRegExp, (match, key) => {
                const value = getKeyFromMappedResult(key.trim());
                return value !== null ? value : match;
            });
        }
        return str;
    }

    //TODO - fix scrolling later, for now popup-no-scroll class is not doing anything
    const onMouseEnterHandler = () => {
        document.body.classList.add('popup-no-scroll');
    }

    const onMouseLeaveHandler = () => {
        document.body.classList.remove('popup-no-scroll');
    }

    useEffect(() => {
        if (!isActive) {
            document.body.classList.remove('popup-no-scroll');
        }
    }, [isActive])

    useEffect(() => {
        answer_agent_profile?.popup_waiting_duration && customSetTimeout(() => setIsActive(true), answer_agent_profile?.popup_waiting_duration * 1000)
    }, [answer_agent_profile])

    return (
        <Modal id="popup-card" className="slide-up"
            isOpen={isActive && answer_agent_profile?.show_popup && isFeatureFlagActive(REQUIRED_FEATURE_FLAGS.SF_FEATURE_FLAG_SHOW_POPUP_IN_GOAL_FORM)}
            backdrop={true}
            fade={false}
            backdropClassName="no-backdrop-color"
            scrollable={true}
            onMouseEnter={onMouseEnterHandler}
            onMouseLeave={onMouseLeaveHandler}
        >
            <div className="form-popup-green-border">
            </div>
            <ModalHeader className="py-3">
                <Row>
                    <Col md={12} className="my-auto">
                        <div className="d-flex justify-content-center align-items-center">
                            <div className='quote-funnel-answer-footer-img'>
                                {answer_agent_profile?.profile_img_url && (
                                    <div style={{ position: 'relative', display: 'inline-block' }}>
                                        <img
                                            src={answer_agent_profile?.profile_img_url}
                                            alt="Profile Image"
                                            className="goal-form-popup-logo"
                                        />
                                        <div className="user-active-icon">
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='ms-4'>
                                <span className='text-black fw-bold' id="nameSpan">{answer_agent_profile?.name}</span>
                            </div>
                        </div>
                    </Col>
                    <button type="button" className="close mt-2" onClick={HandleModalClose} data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Row>
            </ModalHeader>
            <div
                className="sf-admin-filters-position-relative text-black fs-18 px-3 py-3"
                style={{
                    whiteSpace: 'pre-line',
                    fontFamily: 'Roboto, "Open Sans", "Segoe UI", sans-serif',
                    maxHeight: '200px',
                    overflowY: 'auto'
                }}
            >
                {populateStringWithMacros(currentAgentProfileMessage?.message) || ""}
            </div>
            <a className="mb-4 mt-1 mx-3 text-white btn goal-form-popup-call-now-button btn-lg quote-funnel-answer-btn" href={`tel:${quote_funnel_questions?.tracking_number || ''}`}>
                <span className='d-flex justify-content-center'>
                    <img src={runded_phone_icon} className='me-1' /><span className="call-now-text-font popup-call-now-text qf-call-now-btn-small-screen">
                        Call Now: {formatPhoneNumber(quote_funnel_questions?.tracking_number)}
                    </span>
                </span>
            </a>
        </Modal>
    )
}

export default CallNowPopupModal